import { render, staticRenderFns } from "./BaseAdd.vue?vue&type=template&id=449ba872&scoped=true&"
import script from "./BaseAdd.vue?vue&type=script&lang=js&"
export * from "./BaseAdd.vue?vue&type=script&lang=js&"
import style0 from "./BaseAdd.vue?vue&type=style&index=0&id=449ba872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449ba872",
  null
  
)

export default component.exports